import { render, staticRenderFns } from "./BoxSearch.vue?vue&type=template&id=671cd3ab&scoped=true&"
import script from "./BoxSearch.vue?vue&type=script&lang=js&"
export * from "./BoxSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671cd3ab",
  null
  
)

export default component.exports